import { HttpAgentClient } from '@interaktiv/volto-ai-editor/api/HttpAgentClient';
import {
  HttpError,
  HttpTransport,
} from '@interaktiv/volto-ai-editor/api/HttpTransport';
import { AgentTurn } from '@interaktiv/volto-ai-editor/api/AgentTurn';
import type {
  RemoteToolCall,
  SendMessageOptions,
} from '@interaktiv/volto-ai-editor/types';
import { validatePage } from './page';

/** Keep the stock protocol; identify the matching backend block profile. */
export class BonnTransport extends HttpTransport {
  constructor() {
    super('/_ai-agent');
  }

  request<T>(path: string, options = {}) {
    const request = options as {
      method?: string;
      body?: Record<string, unknown>;
    };
    if (path === '/conversations' && request.body) {
      request.body = { ...request.body, version: 'uni-bonn' };
    }
    return super.request<T>(
      path.replace('version=ai-editor', 'version=uni-bonn'),
      request,
    );
  }
}

class BonnTurn extends AgentTurn {
  currentConversation = () => this.conversationId;

  protected fetchTranscript(turnStart: string) {
    // A restarted backend may recreate the conversation while posting a turn.
    return this.transport
      .request<
        import('@interaktiv/volto-ai-editor/types').RemoteMessage[]
      >(`/conversations/${this.currentConversation()}/messages?after=${turnStart}`)
      .catch(() => null);
  }

  protected toToolCall(call: RemoteToolCall) {
    if (call.state) {
      try {
        validatePage(call.state);
      } catch (error) {
        this.requestCancel();
        throw new HttpError(String(error), 422);
      }
    }
    return super.toToolCall(call);
  }
}

export class LinoAgentClient extends HttpAgentClient {
  constructor() {
    super(new BonnTransport());
  }

  protected newTurn(conversationId: string, options: SendMessageOptions) {
    const turn = new BonnTurn(this.transport, conversationId, options);
    turn.currentConversation = () =>
      this.activeConversation?.conversationId || conversationId;
    return turn;
  }
}
